import { apiClient, APIResponse } from './client';

export interface WorkgroupSearchResult {
  id: number;
  title: string;
  workgrouptype: string;
  requestPending: boolean;
  pendingType: 'INVITATION' | 'JOIN_REQUEST' | null;
}

export interface WorkgroupRequest {
  id: number;
  profileid: number | null;
  email: string | null;
  workgroupid: number;
  requesttype: 'INVITATION' | 'JOIN_REQUEST';
  requestedon: string;
  requestedby: number;
  requeststatus: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  roleid?: number | null;
  roles?: { id: number; rolename: string } | null;
  workgroups?: { id: number; title: string };
  requestedbyprofile?: { firstname: string; lastname?: string; emailid: string };
  profiles_profileidToprofiles?: { firstname: string; lastname?: string; emailid: string };
}

export class WorkgroupRequestsAPI {
  static async search(q: string): Promise<APIResponse<WorkgroupSearchResult[]>> {
    return apiClient.get<WorkgroupSearchResult[]>('/workgroup-requests/search', { q });
  }

  static async invite(email: string, roleId?: number) {
    return apiClient.post<{ message: string }>('/workgroup-requests/invite', { email, roleid: roleId });
  }

  static async join(workgroupId: number) {
    return apiClient.post<{ message: string }>('/workgroup-requests/join', { workgroupId });
  }

  static async listInvitations(): Promise<APIResponse<WorkgroupRequest[]>> {
    return apiClient.get<WorkgroupRequest[]>('/workgroup-requests/invitations');
  }

  static async listRequests(): Promise<APIResponse<WorkgroupRequest[]>> {
    return apiClient.get<WorkgroupRequest[]>('/workgroup-requests/requests');
  }

  static async listSentInvitations(): Promise<APIResponse<WorkgroupRequest[]>> {
    return apiClient.get<WorkgroupRequest[]>('/workgroup-requests/sent-invitations');
  }

  static async accept(id: number, roleId?: number) {
    return apiClient.post<{ message: string }>(`/workgroup-requests/${id}/accept`, { roleid: roleId });
  }

  static async reject(id: number) {
    return apiClient.post<{ message: string }>(`/workgroup-requests/${id}/reject`);
  }
}
